import { API_PREFIX, CaseId } from '../types';
import getAll from './getAll';
import patch from './patch';
import switchStatus from './switchStatus';
import { TaskId, TaskStatus } from './Task';

const indexFunc = (caseId: CaseId) => ({
  getAll: () => getAll(`${API_PREFIX}/${caseId}`),
  updateStatus: (taskId: TaskId, taskStatus: TaskStatus) => patch(`${API_PREFIX}/${caseId}`, taskId, taskStatus),
  switchStatus: (taskId: TaskId, newStatus: TaskStatus) => switchStatus(`${API_PREFIX}/${caseId}`, taskId, newStatus),
});

export default indexFunc;
